import { graphql } from "relay-runtime"

const chCallButtonQuery = graphql`
  query chCallButtonQuery($id: ID!) {
    callLineInformation: ch_callLineInformationByPatientId(id: $id) {
      callLine
      isRecorded
    }
  }
`

export { chCallButtonQuery }
